import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

/**
 * Защищённый маршрут — требует авторизации.
 * Неавторизованных пользователей перенаправляет на /login.
 */
const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!isAuthenticated()) {
            navigate('/login', { state: { from: location.pathname }, replace: true });
        }
    }, [navigate, location.pathname]);

    if (!isAuthenticated()) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <div>Загрузка...</div>
            </div>
        );
    }

    return children;
};

export default ProtectedRoute;
